var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.134a1 1 0 010 1.732l-9 5.196a1 1 0 01-1.5-.866V1.804A1 1 0 011.5.938l9 5.196z",
    fill: "currentColor"
  })));
}
export default SvgPlay;